import { CollectionEntity } from "@busy-human/gearbox";
export var ChecklistOverrides;
(function (ChecklistOverrides) {
    function Default() {
        return {
            definitionId: '',
            tripId: '',
            description: '',
            personApplicability: ['unspecified'],
            dueDateType: 'relative',
            dueDateRelative: "1 days after registration",
            modifiedTimestamp: null
        };
    }
    ChecklistOverrides.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getAllAsMap() {
            return new Map((await this.fetchAll()).dataItems().map(b => ([b.$id, b])));
        }
    }
    ChecklistOverrides.CollectionClass = CollectionClass;
    ChecklistOverrides.Collection = new CollectionClass({ path: "/Checklist-Overrides" });
})(ChecklistOverrides || (ChecklistOverrides = {}));
//# sourceMappingURL=index.js.map